import React, { useState } from 'react';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import LibModal from '../../../../../../features/LibModal/LibModal';
import UpdatePackageModal from '../../Modals/UpdatePackageModal';
import { useProductDt } from '../../ProductDetailsProvider';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

const demoData = [
    {
        id: 1,
        applicationId: 20,
        role: 'customer',
        packageName: 'Basic Package',
        priority: 0,
        prices: [],
        status: '',
        demo: true
    }
];

function PackagesTable() {
    const [packageItem, setPackageItem] = useState(0);
    const { productInfo, openModal, handleSelectPackage, handleReload } = useProductDt();
    const data = productInfo?.packages || demoData;
    const isProductInactive = productInfo?.status === 'inactive';

    const handleEditClick = (ev, item) => {
        ev.preventDefault();
        ev.stopPropagation();
        setPackageItem(item);
    };

    return (
        <>
            <LayoutProvider>
                <TableWeb
                    layout="default"
                    data={data}
                    openModal={openModal}
                    handleSelectPackage={handleSelectPackage}
                    isProductInactive={isProductInactive}
                    handleEditClick={handleEditClick}
                />
                <TableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={data}
                    openModal={openModal}
                    handleSelectPackage={handleSelectPackage}
                    isProductInactive={isProductInactive}
                    handleEditClick={handleEditClick}
                />
            </LayoutProvider>

            {packageItem?.id && (
                <LibModal title="Update Package" setOpen={setPackageItem}>
                    <UpdatePackageModal
                        closeModal={() => setPackageItem(0)}
                        handleReload={handleReload}
                        data={packageItem}
                    />
                </LibModal>
            )}
        </>
    );
}

export default PackagesTable;
